import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../utils/Breakpoints';
import { fonts, colors } from '../../utils/config';

import Icon from './icon';

const StyledMenuItem = styled.div`
	flex: 0 1 16.66666%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 72px;
	width: 56px;
	text-align: center;
	user-select: none;

	&:hover {
		cursor: pointer;
	}

	&:hover {
		svg path {
			fill: #fff;
		}
	}

	${media.lg`
		height: 96px;
		width: 76px;
	`}

	&[data-icon='alle'] {
		div {
			background-color: ${props => (props.active ? `${colors.cyandark}` : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: ${colors.cyandark};
		}
	}

	&[data-icon='mehr'] {
		div {
			background-color: ${props => (props.active ? `${colors.cyandark}` : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: ${colors.cyandark};
		}
	}

	&[data-icon='regiorad'] {
		div {
			background-color: ${props => (props.active ? '#06507F' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #06507f;
		}
	}

	&[data-icon='stella'] {
		div {
			background-color: ${props => (props.active ? '#18ACE9' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #18ace9;
		}
	}

	&[data-icon='stadtmobil'] {
		div {
			background-color: ${props => (props.active ? '#E2000F' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #e2000f;
		}
	}

	&[data-icon='car2go'],
	&[data-icon='sharenow'] {
		div {
			background-color: ${props => (props.active ? '#1498E3' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #1498e3;
		}
	}

	&[data-icon='flinkster'] {
		div {
			background-color: ${props => (props.active ? '#E2000F' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #e2000f;
		}
	}

	&[data-icon='rbahn']:hover svg path {
		fill: ${colors.grayblue};
	}
	${props =>
		props.active
			? `
			&[data-icon='rbahn'] svg path {
				fill: ${colors.grayblue};
			}`
			: ''}

	&[data-icon='sbahn']:hover svg path {
		fill: #52b331;
	}
	${props =>
		props.active
			? `
			&[data-icon='sbahn'] svg path {
				fill: #52b331;
			}`
			: ''}

	&[data-icon='ubahn']:hover svg path {
		fill: #0aa1e2;
	}
	${props =>
		props.active
			? `
			&[data-icon='ubahn'] svg path {
				fill: #0aa1e2;
			}`
			: ''}

	&[data-icon='bus']:hover svg path {
		fill: #c31924;
	}
	${props =>
		props.active
			? `
			&[data-icon='bus'] svg path {
				fill: #c31924;
			}`
			: ''}

	${props =>
		props.type === 'places' &&
		`
		&:hover div {
			background-color: ${colors.orange};
		}
	`}

	${props =>
		props.type === 'places' &&
		props.active &&
		`
		div {
			background-color: ${colors.orange};
		}
	`}
`;

const Title = styled.h2`
	height: ${props => (props.type === 'sharing' ? 'auto' : '24px')};
	margin-top: 4px;
	font-size: 12px;
	line-height: 1;
	font-family: ${fonts.default};
	font-weight: normal;
	color: ${colors.black};
`;

export default function MenuItem({ title, titlefilter, icon, type, active, onClick }) {
	return (
		<StyledMenuItem
			active={active}
			type={type}
			data-icon={icon}
			onClick={onClick}
			titlefilter={titlefilter}
		>
			<Icon icon={icon} type={type} active={active} />
			<Title type={type}>{title}</Title>
		</StyledMenuItem>
	);
}

MenuItem.propTypes = {
	icon: PropTypes.oneOf([
		'alle',
		'freizeit',
		'essentrinken',
		'kultur',
		'sehenswuerdigkeiten',
		'rundumsrad',
		'bildungseinrichtungen',
		'krankenhaeuserkliniken',
		'verbaendevereine',
		'mehr',
		'stella',
		'car2go',
		'sharenow',
		'flinkster',
		'regiorad',
		'stadtmobil',
		'rbahn',
		'sbahn',
		'ubahn',
		'bus',
	]).isRequired,
	title: PropTypes.string.isRequired,
	titlefilter: PropTypes.string,
	type: PropTypes.string,
	active: PropTypes.bool,
	onClick: PropTypes.func,
};
